import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight, TruckIcon, GiftIcon, PercentIcon, AwardIcon, X, Wine, Quote, User, Mail, Phone, Calendar, Clock, Users, MapPin, Check } from 'lucide-react';
export function WineClubPage() {
  const [showPinkModal, setShowPinkModal] = useState(false);
  const [showPremiumModal, setShowPremiumModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    tastingDate: '',
    tastingTime: '',
    numberOfPeople: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Handle form submission
  };
  const partnerLogos = [{
    name: 'Blaxland Inn',
    url: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/Blaxland-Inn-Logo.png',
    link: 'https://blaxlandinn.com.au'
  }, {
    name: 'Tallavera Grove',
    url: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/Tallavera-Grove-Logo.png',
    link: 'https://tallaveragrove.com.au'
  }, {
    name: 'Tulloch Wines',
    url: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/Tulloch-Logo.png',
    link: 'https://tullochwines.com'
  }];
  const pinkClubOptions = [{
    name: 'Pink Club - Blush',
    description: 'Our signature Pink Blush Rosé selection'
  }, {
    name: 'Pink Club - Moscato',
    description: 'Our Sweet for Everyone Moscato'
  }, {
    name: 'Pink Club - Shades',
    description: 'A curated selection of sweet sparkling'
  }, {
    name: 'Pink Club - Special',
    description: 'A create your own sweet sparkling selection'
  }];
  const premiumClubOptions = [{
    name: 'Premium Club - Mixed Four',
    description: 'Four bottles of mixed premium sparkling red & white'
  }, {
    name: 'Premium Club - Mixed Six',
    description: 'Six bottles of mixed premium selections'
  }, {
    name: 'Premium Club - Red',
    description: 'Four bottles of mixed premium sparkling red'
  }, {
    name: 'Premium Club - White',
    description: 'Four bottles of mixed premium sparkling white'
  }, {
    name: 'Premium Club - Special',
    description: 'A create your own premium sparkling selection'
  }];
  return <div className="min-h-screen bg-white" data-id="element-1856">
      {/* Header */}
      <Header variant="light" data-id="element-1857" />

      {/* Hero Section */}
      <section className="relative py-32 px-8 overflow-hidden" data-id="element-1858">
        <div className="absolute inset-0 z-0" style={{
        backgroundImage: 'url(https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/12/Peterson-House-Wine-Club.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }} data-id="element-1859" />
        <div className="absolute inset-0 bg-black/50 z-10" data-id="element-1860" />

        {/* Content */}
        <div className="max-w-4xl mx-auto text-center relative z-20 px-6 sm:px-8 h-full flex flex-col justify-center py-20" data-id="element-1861">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-1862" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-1863">
            Join Us
          </div>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight" data-id="element-1864">
            Welcome Bubble Lovers
          </h1>
          <p className="text-xl text-white/90 leading-relaxed max-w-3xl mx-auto" data-id="element-1865">
            Join the Peterson House Wine Club and enjoy exclusive benefits,
            premium tastings, and member-only events throughout the year.
          </p>
        </div>
      </section>

      {/* Member Benefits Section */}
      <section className="bg-white py-20 px-8" data-id="element-1866">
        <div className="max-w-7xl mx-auto" data-id="element-1867">
          <div className="text-center mb-16" data-id="element-1868">
            <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-1869" />
            <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-1870">
              Exclusive Perks
            </div>
            <h2 className="font-heading text-5xl font-normal text-neutral-900 mb-6" data-id="element-1871">
              Member Benefits
            </h2>
            <p className="text-lg text-neutral-600 max-w-3xl mx-auto leading-relaxed" data-id="element-1872">
              Experience the finest privileges with your Peterson House Wine
              Club membership
            </p>
          </div>

          {/* Asymmetric Grid Layout */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8 lg:items-stretch" data-id="element-1873">
            {/* Large Featured Card - 15% Wine Discount */}
            <div className="bg-brand-pink p-12 flex flex-col justify-center items-center text-center min-h-[600px]" data-id="element-1874">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mb-8" data-id="element-1875">
                <Wine className="w-12 h-12 text-white" data-id="element-1876" />
              </div>
              <h3 className="font-heading text-5xl text-white mb-6 leading-tight" data-id="element-1877">
                15% Off
                <br data-id="element-1878" />
                Wine & Merchandise Purchases
              </h3>
              <p className="text-xl text-white/90 leading-relaxed max-w-md" data-id="element-1879">
                Save on all your favourite bottles with an exclusive discount on
                every wine purchase
              </p>
              <div className="mt-8 pt-8 border-t border-white/20" data-id="element-1880">
                <p className="text-white/80 text-sm" data-id="element-1881">
                  Your biggest member benefit
                </p>
              </div>
            </div>

            {/* Smaller Cards Grid - 2 columns x 3 rows */}
            <div className="flex flex-col gap-6 h-full" data-id="element-1882">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 flex-1" data-id="element-1883">
                {/* No Joining Fee */}
                <div className="bg-white border border-neutral-200 p-6" data-id="element-1884">
                  <div className="flex items-start gap-3 mb-3" data-id="element-1885">
                    <Wine className="w-5 h-5 text-brand-pink mt-1 flex-shrink-0" data-id="element-1886" />
                    <div data-id="element-1887">
                      <h4 className="font-medium text-neutral-900 mb-2" data-id="element-1888">
                        No Joining Fee
                      </h4>
                      <p className="text-sm text-neutral-600 leading-relaxed" data-id="element-1889">
                        Start your membership today at no cost
                      </p>
                    </div>
                  </div>
                </div>

                {/* Restaurant Discount */}
                <div className="bg-white border border-neutral-200 p-6" data-id="element-1890">
                  <div className="flex items-start gap-3 mb-3" data-id="element-1891">
                    <Wine className="w-5 h-5 text-brand-pink mt-1 flex-shrink-0" data-id="element-1892" />
                    <div data-id="element-1893">
                      <h4 className="font-medium text-neutral-900 mb-2" data-id="element-1894">
                        15% Dining Discount
                      </h4>
                      <p className="text-sm text-neutral-600 leading-relaxed" data-id="element-1895">
                        At Restaurant Cuvée & Blaxland Inn
                      </p>
                    </div>
                  </div>
                </div>

                {/* Private Tasting */}
                <div className="bg-white border border-neutral-200 p-6" data-id="element-1896">
                  <div className="flex items-start gap-3 mb-3" data-id="element-1897">
                    <Wine className="w-5 h-5 text-brand-pink mt-1 flex-shrink-0" data-id="element-1898" />
                    <div data-id="element-1899">
                      <h4 className="font-medium text-neutral-900 mb-2" data-id="element-1900">
                        Private Tasting*
                      </h4>
                      <p className="text-sm text-neutral-600 leading-relaxed" data-id="element-1901">
                        Bubbles tailored for you plus a cheese platter
                      </p>
                    </div>
                  </div>
                </div>

                {/* Exclusive Events */}
                <div className="bg-white border border-neutral-200 p-6" data-id="element-1902">
                  <div className="flex items-start gap-3 mb-3" data-id="element-1903">
                    <Wine className="w-5 h-5 text-brand-pink mt-1 flex-shrink-0" data-id="element-1904" />
                    <div data-id="element-1905">
                      <h4 className="font-medium text-neutral-900 mb-2" data-id="element-1906">
                        Exclusive Events**
                      </h4>
                      <p className="text-sm text-neutral-600 leading-relaxed" data-id="element-1907">
                        Member-only events and special functions
                      </p>
                    </div>
                  </div>
                </div>

                {/* E-Newsletters */}
                <div className="bg-white border border-neutral-200 p-6" data-id="element-1908">
                  <div className="flex items-start gap-3 mb-3" data-id="element-1909">
                    <Wine className="w-5 h-5 text-brand-pink mt-1 flex-shrink-0" data-id="element-1910" />
                    <div data-id="element-1911">
                      <h4 className="font-medium text-neutral-900 mb-2" data-id="element-1912">
                        E-Newsletters
                      </h4>
                      <p className="text-sm text-neutral-600 leading-relaxed" data-id="element-1913">
                        Exclusive offers and upcoming events
                      </p>
                    </div>
                  </div>
                </div>

                {/* Sister Companies Discount */}
                <div className="bg-white border border-neutral-200 p-6" data-id="element-1914">
                  <div className="flex items-start gap-3 mb-3" data-id="element-1915">
                    <Wine className="w-5 h-5 text-brand-pink mt-1 flex-shrink-0" data-id="element-1916" />
                    <div data-id="element-1917">
                      <h4 className="font-medium text-neutral-900 mb-2" data-id="element-1918">
                        10% Off Our Partner Companies***
                      </h4>
                      <p className="text-sm text-neutral-600 leading-relaxed" data-id="element-1919">
                        Extended benefits across our wineries
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Footnotes Bar - Full Width at Bottom */}
              <div className="bg-neutral-900 px-6 py-4" data-id="element-1920">
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-6 text-xs text-neutral-300" data-id="element-1921">
                  <p data-id="element-1922">
                    <span className="text-brand-pink font-medium" data-id="element-1923">*</span>{' '}
                    Bookings essential. Up to six guests only.
                  </p>
                  <p data-id="element-1924">
                    <span className="text-brand-pink font-medium" data-id="element-1925">**</span> See
                    members events page for details.
                  </p>
                  <p data-id="element-1926">
                    <span className="text-brand-pink font-medium" data-id="element-1927">***</span> See
                    our Partner Companies below.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Club Options Section */}
      <section className="bg-white py-12 px-8 relative overflow-hidden" data-id="element-1928">
        {/* Bubble Background */}
        <div className="absolute inset-0 pointer-events-none opacity-10 z-0" style={{
        backgroundImage: 'url(https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/bubbles-scaled.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }} data-id="element-1929" />

        <div className="max-w-7xl mx-auto relative z-10" data-id="element-1930">
          <div className="text-center mb-12" data-id="element-1931">
            <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-1932" />
            <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-1933">
              Membership
            </div>
            <h2 className="font-heading text-5xl font-normal text-neutral-900 mb-6" data-id="element-1934">
              Wine Club
            </h2>
            <p className="text-lg text-neutral-600 max-w-3xl mx-auto leading-relaxed" data-id="element-1935">
              Join our exclusive wine club and enjoy regular shipments of our
              finest wines, member-only events, and special discounts.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-1936">
            {/* Pink Club */}
            <div className="border border-neutral-200 rounded-none p-8 flex flex-col bg-white" data-id="element-1937">
              <h3 className="font-heading text-2xl font-normal text-neutral-900 mb-4 text-center" data-id="element-1938">
                The Pink Club
              </h3>
              <p className="text-base text-neutral-600 mb-6 leading-relaxed text-left flex-1" data-id="element-1939">
                The Pink Club is perfect for lovers of sweeter bubbles,
                featuring our famous Pink Blush and more. Enjoy three deliveries
                of six bottles in April, August, and November — choose our
                curated selection or create your own custom pack.
              </p>
              <div className="space-y-3 mb-8" data-id="element-1940">
                <div className="flex items-center gap-3 text-neutral-600" data-id="element-1941">
                  <TruckIcon className="w-5 h-5 text-neutral-500" data-id="element-1942" />
                  <span className="text-sm" data-id="element-1943">3 deliveries per year</span>
                </div>
                <div className="flex items-center gap-3 text-neutral-600" data-id="element-1944">
                  <GiftIcon className="w-5 h-5 text-neutral-500" data-id="element-1945" />
                  <span className="text-sm" data-id="element-1946">6 bottles per delivery</span>
                </div>
                <div className="flex items-center gap-3 text-neutral-600" data-id="element-1947">
                  <PercentIcon className="w-5 h-5 text-neutral-500" data-id="element-1948" />
                  <span className="text-sm" data-id="element-1949">Exclusive member discounts</span>
                </div>
              </div>
              <div className="flex justify-center" data-id="element-1950">
                <button onClick={() => setShowPinkModal(true)} className="bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium inline-flex items-center justify-center gap-2 rounded-none group" data-id="element-1951">
                  Join Pink
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1952" />
                </button>
              </div>
            </div>

            {/* Premium Club */}
            <div className="border border-neutral-200 rounded-none p-8 flex flex-col bg-white" data-id="element-1953">
              <h3 className="font-heading text-2xl font-normal text-neutral-900 mb-4 text-center" data-id="element-1954">
                The Premium Club
              </h3>
              <p className="text-base text-neutral-600 mb-6 leading-relaxed text-left flex-1" data-id="element-1955">
                The Premium Club is for those who love drier, traditional
                méthode sparkling wines. Receive three deliveries of four
                bottles in March, June, and October — featuring our newest
                releases, handpicked by the winemaker before public release.
              </p>
              <div className="space-y-3 mb-8" data-id="element-1956">
                <div className="flex items-center gap-3 text-neutral-600" data-id="element-1957">
                  <TruckIcon className="w-5 h-5 text-neutral-500" data-id="element-1958" />
                  <span className="text-sm" data-id="element-1959">3 deliveries per year</span>
                </div>
                <div className="flex items-center gap-3 text-neutral-600" data-id="element-1960">
                  <AwardIcon className="w-5 h-5 text-neutral-500" data-id="element-1961" />
                  <span className="text-sm" data-id="element-1962">Winemaker selections</span>
                </div>
                <div className="flex items-center gap-3 text-neutral-600" data-id="element-1963">
                  <PercentIcon className="w-5 h-5 text-neutral-500" data-id="element-1964" />
                  <span className="text-sm" data-id="element-1965">Priority access to releases</span>
                </div>
              </div>
              <div className="flex justify-center" data-id="element-1966">
                <button onClick={() => setShowPremiumModal(true)} className="bg-brand-grey text-white px-8 py-4 hover:bg-neutral-700 transition-colors font-medium inline-flex items-center justify-center gap-2 rounded-none group" data-id="element-1967">
                  Join Premium
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1968" />
                </button>
              </div>
            </div>
          </div>

          {/* Customer Review */}
          <div className="mt-16 max-w-3xl mx-auto" data-id="element-1969">
            <div className="bg-white border border-neutral-200 rounded-none p-8 md:p-12" data-id="element-1970">
              <div className="flex justify-center mb-6" data-id="element-1971">
                <Quote className="w-12 h-12 text-brand-pink opacity-20" data-id="element-1972" />
              </div>
              <blockquote className="text-center" data-id="element-1973">
                <p className="text-base text-neutral-700 mb-6 leading-relaxed italic" data-id="element-1974">
                  Joining the Pink Club has been one of the best decisions we've
                  made. Every delivery feels like a celebration, and the quality
                  of the sparkling wines is exceptional.
                </p>
                <footer className="text-center" data-id="element-1975">
                  <p className="text-sm font-medium text-neutral-900" data-id="element-1976">
                    Sarah Mitchell
                  </p>
                  <p className="text-xs text-neutral-500" data-id="element-1977">
                    Pink Club Member since 2022
                  </p>
                </footer>
              </blockquote>
            </div>
          </div>
        </div>
      </section>

      {/* Member Tasting Booking Section */}
      <section className="bg-neutral-900 py-20 px-8" data-id="element-1978">
        <div className="max-w-3xl mx-auto" data-id="element-1979">
          <div className="text-center mb-12" data-id="element-1980">
            <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-1981" />
            <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-1982">
              Book Your Experience
            </div>
            <h2 className="font-heading text-5xl font-normal text-white mb-6" data-id="element-1983">
              Peterson House Club Member Tasting
            </h2>
            <p className="text-base text-neutral-300 mb-6 leading-relaxed" data-id="element-1984">
              Member Tastings are for up to six guests only. For extra guests,
              an additional payment required.
            </p>
            <p className="text-sm text-neutral-400 leading-relaxed" data-id="element-1985">
              The Club office is unattended Saturdays & Sundays. To avoid
              disappointment please submit forms by 4.30pm Friday. For urgent
              enquiries or if you have not received confirmation, please call
              the Cellar Door 02 4998 7881.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1986">
            <div className="grid md:grid-cols-2 gap-6" data-id="element-1987">
              <div data-id="element-1988">
                <label htmlFor="name" className="block text-sm text-neutral-300 mb-2" data-id="element-1989">
                  Name *
                </label>
                <div className="relative" data-id="element-1990">
                  <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-1991" />
                  <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} placeholder="Enter your name" className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors placeholder-neutral-400" data-id="element-1992" />
                </div>
              </div>

              <div data-id="element-1993">
                <label htmlFor="email" className="block text-sm text-neutral-300 mb-2" data-id="element-1994">
                  Email *
                </label>
                <div className="relative" data-id="element-1995">
                  <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-1996" />
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} placeholder="your@email.com" className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors placeholder-neutral-400" data-id="element-1997" />
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-1998">
              <div data-id="element-1999">
                <label htmlFor="phone" className="block text-sm text-neutral-300 mb-2" data-id="element-2000">
                  Phone *
                </label>
                <div className="relative" data-id="element-2001">
                  <Phone className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-2002" />
                  <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} placeholder="0400 000 000" className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors placeholder-neutral-400" data-id="element-2003" />
                </div>
              </div>

              <div data-id="element-2004">
                <label htmlFor="tastingDate" className="block text-sm text-neutral-300 mb-2" data-id="element-2005">
                  Tasting Date *
                </label>
                <div className="relative" data-id="element-2006">
                  <Calendar className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-2007" />
                  <input type="date" id="tastingDate" name="tastingDate" required value={formData.tastingDate} onChange={handleChange} className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors" data-id="element-2008" />
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-2009">
              <div data-id="element-2010">
                <label htmlFor="tastingTime" className="block text-sm text-neutral-300 mb-2" data-id="element-2011">
                  Preferred Tasting Time *
                </label>
                <div className="relative" data-id="element-2012">
                  <Clock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-2013" />
                  <input type="time" id="tastingTime" name="tastingTime" required value={formData.tastingTime} onChange={handleChange} className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors" data-id="element-2014" />
                </div>
              </div>

              <div data-id="element-2015">
                <label htmlFor="numberOfPeople" className="block text-sm text-neutral-300 mb-2" data-id="element-2016">
                  Number of People *
                </label>
                <div className="relative" data-id="element-2017">
                  <Users className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-2018" />
                  <select id="numberOfPeople" name="numberOfPeople" required value={formData.numberOfPeople} onChange={handleChange} className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors appearance-none cursor-pointer" data-id="element-2019">
                    <option value="" data-id="element-2020">Select number</option>
                    <option value="1" data-id="element-2021">1 person</option>
                    <option value="2" data-id="element-2022">2 people</option>
                    <option value="3" data-id="element-2023">3 people</option>
                    <option value="4" data-id="element-2024">4 people</option>
                    <option value="5" data-id="element-2025">5 people</option>
                    <option value="6" data-id="element-2026">6 people</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="text-center pt-4" data-id="element-2027">
              <button type="submit" className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-4 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-2028">
                <Calendar size={18} data-id="element-2029" />
                Book Member Tasting
                <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-2030" />
              </button>
            </div>

            <p className="text-center text-sm text-neutral-400 mt-6" data-id="element-2031">
              *Bookings essential to avoid disappointment. For up to six guests
              only.
            </p>
            <p className="text-center text-sm text-neutral-400" data-id="element-2032">
              **You will receive an email confirmation once your booking has
              been secured.
            </p>
          </form>
        </div>
      </section>

      {/* Member Events Section */}
      <section className="bg-white py-20 px-8" data-id="element-2033">
        <div className="max-w-7xl mx-auto" data-id="element-2034">
          <div className="text-center mb-12" data-id="element-2035">
            <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-2036" />
            <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-2037">
              Exclusive Access
            </div>
            <h2 className="font-heading text-5xl font-normal text-neutral-900 mb-6" data-id="element-2038">
              Member Events
            </h2>
            <p className="text-lg text-neutral-600 max-w-3xl mx-auto leading-relaxed mb-8" data-id="element-2039">
              Harvest Experience • Bubbleologist Experience • Sydney Harbour
              Cruise • Christmas in July • Exclusive Members Dinners
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-2040">
            {/* Entrata Dinner Event */}
            <div className="bg-white border border-neutral-200 rounded-none overflow-hidden" data-id="element-2041">
              <div className="relative aspect-[4/3] bg-gray-300" data-id="element-2042">
                <img src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?q=80&w=2940" alt="Christmas in July celebration" className="w-full h-full object-cover" data-id="element-2043" />
              </div>
              <div className="p-8" data-id="element-2044">
                <div className="mb-4" data-id="element-2045">
                  <div className="text-brand-pink text-xs tracking-[0.3em] font-light uppercase mb-2" data-id="element-2046">
                    Annual Event
                  </div>
                  <h3 className="font-heading text-2xl font-normal text-neutral-900 mb-3" data-id="element-2047">
                    Christmas in July
                  </h3>
                  <p className="text-sm text-neutral-600 mb-4" data-id="element-2048">
                    Peterson House Annual Members Event
                  </p>
                </div>
                <div className="space-y-2 mb-6 text-sm text-neutral-600" data-id="element-2049">
                  <div className="flex items-center gap-2" data-id="element-2050">
                    <Calendar className="w-4 h-4 text-brand-pink" data-id="element-2051" />
                    <span data-id="element-2052">Saturday 11th July 2026</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-2053">
                    <MapPin className="w-4 h-4 text-brand-pink" data-id="element-2054" />
                    <span data-id="element-2055">Peterson House, Hunter Valley</span>
                  </div>
                </div>
                <p className="text-sm text-brand-pink font-medium mb-4" data-id="element-2056">
                  More details coming soon
                </p>
                <p className="text-sm text-neutral-600 mb-6 leading-relaxed" data-id="element-2057">
                  Previously known as Christmas in July, Peterson House will
                  host an event on site with delicious food created by our
                  wonderful team of chefs, with bubbles flowing and
                  entertainment, it's a popular annual event our members love.
                </p>
                <button className="inline-flex items-center gap-2 bg-neutral-300 text-neutral-500 px-8 py-3 font-medium rounded-none w-full justify-center cursor-not-allowed" data-id="element-2058">
                  Coming Soon
                </button>
                <p className="text-xs text-neutral-500 mt-4 text-center" data-id="element-2059">
                  Call 02 4998 7881 ext 1 or email club@petersonhouse.com.au
                </p>
              </div>
            </div>

            {/* Sydney Harbour Cruise Event */}
            <div className="bg-white border border-neutral-200 rounded-none overflow-hidden" data-id="element-2060">
              <div className="relative aspect-[4/3] bg-gray-300" data-id="element-2061">
                <img src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=80&w=2940" alt="Sydney Harbour" className="w-full h-full object-cover" data-id="element-2062" />
              </div>
              <div className="p-8" data-id="element-2063">
                <div className="mb-4" data-id="element-2064">
                  <div className="text-brand-pink text-xs tracking-[0.3em] font-light uppercase mb-2" data-id="element-2065">
                    Annual Cruise
                  </div>
                  <h3 className="font-heading text-2xl font-normal text-neutral-900 mb-3" data-id="element-2066">
                    Sydney Harbour Wine Cruise
                  </h3>
                  <p className="text-sm text-neutral-600 mb-4" data-id="element-2067">
                    Peterson House 7th Annual Wine Harbour Cruise - Black & Pink
                    Party
                  </p>
                </div>
                <div className="space-y-2 mb-6 text-sm text-neutral-600" data-id="element-2068">
                  <div className="flex items-center gap-2" data-id="element-2069">
                    <MapPin className="w-4 h-4 text-brand-pink" data-id="element-2070" />
                    <span data-id="element-2071">Darling Harbour Sydney</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-2072">
                    <Calendar className="w-4 h-4 text-brand-pink" data-id="element-2073" />
                    <span data-id="element-2074">Saturday, 28th March 2026</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-2075">
                    <Clock className="w-4 h-4 text-brand-pink" data-id="element-2076" />
                    <span data-id="element-2077">2:00pm – 5:00pm</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-2078">
                    <Wine className="w-4 h-4 text-brand-pink" data-id="element-2079" />
                    <span className="font-medium" data-id="element-2080">$150 per person</span>
                  </div>
                </div>
                <p className="text-sm text-neutral-600 mb-6 leading-relaxed" data-id="element-2081">
                  Set sail for an unforgettable afternoon! Dress in black/pink,
                  enjoy bubbles, canapés, and breathtaking harbour views.
                </p>
                <button className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group w-full justify-center" data-id="element-2082">
                  Book Now
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-2083" />
                </button>
                <p className="text-xs text-neutral-500 mt-4 text-center" data-id="element-2084">
                  Call 02 4998 7881 ext 1 or email club@petersonhouse.com.au
                </p>
              </div>
            </div>

            {/* Bubbleologist Experience Event */}
            <div className="bg-white border border-neutral-200 rounded-none overflow-hidden" data-id="element-2085">
              <div className="relative aspect-[4/3] bg-gray-300" data-id="element-2086">
                <img src="https://images.unsplash.com/photo-1547595628-c61a29f496f0?q=80&w=2787" alt="Wine making experience" className="w-full h-full object-cover" data-id="element-2087" />
              </div>
              <div className="p-8" data-id="element-2088">
                <div className="mb-4" data-id="element-2089">
                  <div className="text-brand-pink text-xs tracking-[0.3em] font-light uppercase mb-2" data-id="element-2090">
                    Hands-On Experience
                  </div>
                  <h3 className="font-heading text-2xl font-normal text-neutral-900 mb-3" data-id="element-2091">
                    Bubbleologist Experience
                  </h3>
                  <p className="text-sm text-neutral-600 mb-4" data-id="element-2092">
                    Experience the art of bubble making
                  </p>
                </div>
                <div className="space-y-2 mb-6 text-sm text-neutral-600" data-id="element-2093">
                  <div className="flex items-center gap-2" data-id="element-2094">
                    <Calendar className="w-4 h-4 text-brand-pink" data-id="element-2095" />
                    <span data-id="element-2096">2026 DATE TO BE ANNOUNCED SOON</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-2097">
                    <Clock className="w-4 h-4 text-brand-pink" data-id="element-2098" />
                    <span data-id="element-2099">10:00 AM Start | Lunch at 1:00 PM</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-2100">
                    <Wine className="w-4 h-4 text-brand-pink" data-id="element-2101" />
                    <span className="font-medium" data-id="element-2102">$450 for two people</span>
                  </div>
                </div>
                <p className="text-sm text-neutral-600 mb-6 leading-relaxed" data-id="element-2103">
                  Craft your own personalised bubbles, enjoy a four-course
                  wine-matched meal at Cuvee, and take home your creation.
                </p>
                <button className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group w-full justify-center" data-id="element-2104">
                  Book Now
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-2105" />
                </button>
                <p className="text-xs text-neutral-500 mt-4 text-center" data-id="element-2106">
                  Includes workshop, personalised bottles, and Restaurant Cuvee
                  meal
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Associated Companies Section */}
      <section className="bg-neutral-100 py-20 px-8" data-id="element-2107">
        <div className="max-w-6xl mx-auto" data-id="element-2108">
          <div className="text-center mb-12" data-id="element-2109">
            <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-2110" />
            <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-2111">
              Extended Benefits
            </div>
            <h2 className="font-heading text-5xl font-normal text-neutral-900 mb-6" data-id="element-2112">
              Our Partners
            </h2>
            <p className="text-lg text-neutral-600 max-w-3xl mx-auto leading-relaxed" data-id="element-2113">
              When visiting our partner companies, Peterson House Wine Club
              Members will receive a 10% discount.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-8" data-id="element-2114">
            {partnerLogos.map((partner, index) => <a key={index} href={partner.link} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center bg-white border border-neutral-200 p-8 rounded-none hover:border-brand-pink transition-colors group" data-id="element-2115">
                <div className="flex items-center justify-center mb-4 h-24" data-id="element-2116">
                  <img src={partner.url} alt={partner.name} className="w-full h-full object-contain grayscale group-hover:grayscale-0 transition-all" data-id="element-2117" />
                </div>
                <p className="text-sm text-brand-pink font-medium text-center" data-id="element-2118">
                  10% Member Discount
                </p>
              </a>)}
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-2119" />

      {/* Pink Club Modal */}
      {showPinkModal && <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-id="element-2120">
          <div className="bg-white max-w-3xl w-full max-h-[90vh] overflow-y-auto rounded-none" data-id="element-2121">
            <div className="sticky top-0 bg-white border-b border-neutral-200 p-6 flex items-center justify-between" data-id="element-2122">
              <div className="flex items-center gap-4 flex-1 justify-center" data-id="element-2123">
                <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/web-logo.png" alt="Peterson House Logo" className="h-10" data-id="element-2124" />
                <h2 className="font-heading text-3xl text-neutral-900" data-id="element-2125">
                  Choose Your Pink Club
                </h2>
              </div>
              <button onClick={() => setShowPinkModal(false)} className="text-neutral-500 hover:text-neutral-900 transition-colors" data-id="element-2126">
                <X size={24} data-id="element-2127" />
              </button>
            </div>
            <div className="p-8" data-id="element-2128">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2129">
                {pinkClubOptions.map((option, index) => <div key={index} className="relative bg-brand-pink/5 border-2 border-neutral-200 p-6 hover:border-brand-pink transition-all cursor-pointer group text-center" data-id="element-2130">
                    {/* Checkmark on hover */}
                    <div className="absolute top-4 right-4 w-6 h-6 rounded-full bg-brand-pink text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-2131">
                      <Check size={16} data-id="element-2132" />
                    </div>

                    {/* Wine bottle icon */}
                    <div className="flex justify-center mb-4" data-id="element-2133">
                      <div className="w-16 h-16 rounded-full bg-brand-pink/10 flex items-center justify-center group-hover:bg-brand-pink/20 transition-colors" data-id="element-2134">
                        <Wine className="w-8 h-8 text-brand-pink" data-id="element-2135" />
                      </div>
                    </div>

                    {/* Option name */}
                    <h3 className="font-heading text-xl text-neutral-900 mb-3 group-hover:text-brand-pink transition-colors" data-id="element-2136">
                      {option.name}
                    </h3>

                    {/* Description */}
                    <p className="text-sm text-neutral-600 leading-relaxed" data-id="element-2137">
                      {option.description}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>}

      {/* Premium Club Modal */}
      {showPremiumModal && <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-id="element-2138">
          <div className="bg-white max-w-3xl w-full max-h-[90vh] overflow-y-auto rounded-none" data-id="element-2139">
            <div className="sticky top-0 bg-white border-b border-neutral-200 p-6 flex items-center justify-between" data-id="element-2140">
              <div className="flex items-center gap-4 flex-1 justify-center" data-id="element-2141">
                <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/web-logo.png" alt="Peterson House Logo" className="h-10" data-id="element-2142" />
                <h2 className="font-heading text-3xl text-neutral-900" data-id="element-2143">
                  Choose Your Premium Club
                </h2>
              </div>
              <button onClick={() => setShowPremiumModal(false)} className="text-neutral-500 hover:text-neutral-900 transition-colors" data-id="element-2144">
                <X size={24} data-id="element-2145" />
              </button>
            </div>
            <div className="p-8" data-id="element-2146">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2147">
                {premiumClubOptions.map((option, index) => <div key={index} className="relative bg-neutral-50 border-2 border-neutral-200 p-6 hover:border-brand-grey transition-all cursor-pointer group text-center" data-id="element-2148">
                    {/* Checkmark on hover */}
                    <div className="absolute top-4 right-4 w-6 h-6 rounded-full bg-brand-grey text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-2149">
                      <Check size={16} data-id="element-2150" />
                    </div>

                    {/* Wine bottle icon */}
                    <div className="flex justify-center mb-4" data-id="element-2151">
                      <div className="w-16 h-16 rounded-full bg-brand-grey/10 flex items-center justify-center group-hover:bg-brand-grey/20 transition-colors" data-id="element-2152">
                        <Wine className="w-8 h-8 text-brand-grey" data-id="element-2153" />
                      </div>
                    </div>

                    {/* Option name */}
                    <h3 className="font-heading text-xl text-neutral-900 mb-3 group-hover:text-brand-grey transition-colors" data-id="element-2154">
                      {option.name}
                    </h3>

                    {/* Description */}
                    <p className="text-sm text-neutral-600 leading-relaxed" data-id="element-2155">
                      {option.description}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>}
    </div>;
}